import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, DrawerStepper } from '@mercai/clever'

import { QUERIES_ADMIN, useUpdateProfile } from '@/services'

import { FormData as PaymentRepresentativeFormData } from '../form-payment-manager/form-payment-manager.type'
import { PaymentRepresentativeDrawerProps } from './payment-representative-drawer.type'
import { onErrorMessage, onSuccessMessage } from '@/helpers'
import { useQueryClient } from '@tanstack/react-query'
import FormPaymentManager from '../form-payment-manager/form-payment-manager'

export const PaymentRepresentativeDrawer = ({
  isOpen,
  profile,
  onHandleOpen,
}: PaymentRepresentativeDrawerProps) => {
  const { t } = useTranslation('screenProfileShow')

  const queryClient = useQueryClient()

  const [paymentsRepresentativeData, setPaymentsRepresentativeData] =
    useState<PaymentRepresentativeFormData>({
      name: '',
      email: '',
      phone: '',
      addToAccount: false,
    })

  const { mutateAsync } = useUpdateProfile()

  const onSubmitPaymentsRepresentative = async () => {
    const result = await mutateAsync({
      uuid: profile?.uuid || '',
      paymentsRepresentative: {
        ...paymentsRepresentativeData,
      },
    })

    if (result.success) {
      onSuccessMessage(
        t('profileFormSuccessUpdateTitle'),
        t('profileFormSuccessUpdateMessage'),
      )

      queryClient.invalidateQueries({
        queryKey: [QUERIES_ADMIN.PROFILE.module, profile?.uuid || ''],
      })

      onHandleOpen()
    } else {
      onErrorMessage(
        t('profileFormErrorUpdateTitle'),
        t('profileFormErrorUpdateMessage'),
      )
    }
  }

  return (
    <DrawerStepper
      translations={{
        optional: '',
      }}
      isOpen={isOpen}
      onHandleOpen={onHandleOpen}
      title={t('paymentsRepresentativeDrawerTitle')}
      initialStep="root"
      steps={{
        root: {
          isOptional: true,
          backNavigate: 'root',
          component: (
            <FormPaymentManager
              profile={profile}
              data={paymentsRepresentativeData}
              onChange={setPaymentsRepresentativeData}
            />
          ),
          footer: () => (
            <>
              <Button variant="secondary" onClick={onHandleOpen}>
                {t('profileFormNavigateButtonBack')}
              </Button>
              <Button onClick={() => onSubmitPaymentsRepresentative()}>
                {t('profileFormNavigateButtonFinish')}
              </Button>
            </>
          ),
        },
      }}
    />
  )
}
